import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
export const AlignLeftIcon = (_a) => {
    var { size } = _a, rest = __rest(_a, ["size"]);
    return (_jsx("svg", Object.assign({ width: size, height: size }, rest, { viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: _jsx("path", { d: 'M3.75 6.75H20.25M3.75 12H20.25M3.75 17.25H12', stroke: 'currentColor', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }) })));
};
//# sourceMappingURL=align_left.icon.js.map